import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSmartthingsComponent } from './simple-icons-smartthings.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSmartthingsComponent ],
    exports:      [ SimpleIconsSmartthingsComponent ],
    bootstrap:    []
})
export class SimpleIconsSmartthingsModule {}
